var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.82 21.86c-.11-.4.13-.81.54-.92a9.256 9.256 0 0 0 6.89-8.95c0-5.1-4.15-9.25-9.25-9.25-4.33 0-7.17 2.53-8.5 4.06h2.94a.755.755 0 0 1 0 1.51H2.01c-.05 0-.14-.01-.21-.03a.899.899 0 0 1-.24-.12.659.659 0 0 1-.21-.23.808.808 0 0 1-.1-.31V3c0-.41.34-.75.75-.75s.75.34.75.75v2.39C4.38 3.64 7.45 1.25 12 1.25c5.93 0 10.75 4.82 10.75 10.75 0 4.88-3.29 9.16-8.01 10.4-.06.01-.13.02-.19.02-.33 0-.64-.22-.73-.56z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.24 22.72c-1.08-.07-2.14-.31-3.14-.7a.747.747 0 0 1-.43-.97c.15-.38.6-.57.97-.43.87.34 1.78.54 2.7.61.39.02.7.36.7.76l-.01.04c-.02.39-.35.7-.74.7-.02 0-.04-.01-.05-.01zm-5.93-2.3c-.84-.68-1.58-1.47-2.18-2.35a.73.73 0 0 1 .19-1.04.77.77 0 0 1 1.04.18v.01c.01.01.02.03.03.04a9.21 9.21 0 0 0 1.86 1.98c.17.14.28.35.28.58 0 .17-.05.34-.16.48-.15.18-.36.28-.59.28-.17 0-.33-.06-.47-.16zm-3.58-5.24c-.32-1.03-.48-2.1-.48-3.18v-.01c.01-.41.34-.74.75-.74s.75.34.75.75c0 .94.14 1.86.41 2.73.02.08.03.15.03.23a.747.747 0 0 1-.75.74c-.33 0-.62-.21-.71-.52z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRefresh);
export default __webpack_public_path__ + "static/media/vuesax-outline-refresh.f88877a3f3e9517c93c6e3fbc85aee1c.svg";
export { ForwardRef as ReactComponent };